import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'snelstart-venture-fiscaal-feature-tekst-sb-berekening',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './tekst-berekening.component.html',
  styleUrl: './tekst-berekening.component.scss',
})
export class TekstBerekeningComponent {}
